import { Box, styled } from '@mui/material'

export const StyledLine = styled(Box)(({ theme }) => ({
  borderTop: `1px solid ${theme.palette.common.white}`,
  opacity: 0.5,
}))
